import {email, required} from '../units';
import validate from '../common';

const validations = isUsernameEmail => {
  if (isUsernameEmail) {
    return {
      email: [required(), email()]
    };
  }

  return {
    username: [required()]
  };
};

export default isUsernameEmail => ({
  validate: validate(validations(isUsernameEmail))
});



// WEBPACK FOOTER //
// ./validators/forms/reset-password.js